<template>
  <div
    class="app-shell"
    :class="{ 'app-shell--auth': getRoute() === 'signIn' || getRoute() === 'home' }"
  >
    <div
      v-if="getRoute() != 'home' && getRoute() != 'signIn'"
      class="top-0 position-sticky z-index-sticky app-nav-sticky"
    >
      <navbar />
    </div>
    <main
      class="not-for-print main-content app-main position-relative border-radius-lg"
    >
      <router-view @set-loading="setLoading" @to-pdf="toPdf" />
    </main>
    <app-footer v-show="showFooter && getRoute() !== 'signIn'" />
    <quick-actions-fab v-if="getRoute() !== 'signIn'" />
  </div>
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooter from "@/examples/Footer.vue";
import QuickActionsFab from "@/project/Global/Components/QuickActionsFab.vue";
import { mapMutations, mapState } from "vuex";
import Source from "./project/Source/claim.js";
import CryptoJS from "crypto-js";
import * as SignalR from "@aspnet/signalr";
import { signalapi } from "./project/Source/helper.js";
import { currentFullPath, getRouteSection, signInUrl } from "./project/Source/routes.js";

function formatNumber(num) {
  return new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  }).format(num);
}

export default {
  name: "App",
  components: {
    Navbar,
    AppFooter,
    QuickActionsFab,
  },
  data() {
    return {
      bindNavbar: true,
      logoMain: null,
      loading: false,
      eksperText: null,
      sideVis: true,
      clinicAktInfo: null,
      clinicReyesVis: false,
      clinicAktVis: false,
      clinicInfo: {
        sumInsured: null,
        caught: null,
        registerId: null,
        editSumInsured: null,
        status: null,
        saveTitle: null,
        expertiseSumInsured: null,
      },
      retentionSumSum: null,
      clinicTable: null,
      connection: new SignalR.HubConnectionBuilder().withUrl(signalapi).build(),
    };
  },
  computed: {
    ...mapState([
      "isTransparent",
      "isRTL",
      "isPinned",
      "isNavFixed",
      "isAbsolute",
      "navbarFixed",
      "absolute",
      "color",
      "showSidenav",
      "showNavbar",
      "showFooter",
      "showConfig",
      "hideConfigButton",
    ]),
    vatSum() {
      return this.clinicAktInfo.vatSum != 0
        ? `${formatNumber(this.clinicAktInfo.vatSum)} manat (${this.clinicAktInfo.vatSumStr
        })` +
        (this.clinicAktInfo.vatNfc
          ? ` ƏDV tətbiq olunan məbləğ: ${formatNumber(
            this.clinicAktInfo.vatSum / (1.0 - 1.0 / 1.18)
          )}`
          : "")
        : "      ---";
    },
    dateStamp() {
      let actDate = this.clinicAktInfo.actDate;

      let validDate = actDate ? new Date(actDate) : new Date("2000-01-01");

      if (validDate >= new Date("2023-10-01")) {
        return true;
      } else {
        return false;
      }
    },
    signName() {
      let value = false;

      if (this.clinicAktInfo.signerName === "Rəna Daneşvar") {
        value = "@/assets/img/logos/AktAtes/signRena.png";
      } else {
        value = "@/assets/img/logos/AktAtes/signNigar.png";
      }

      return value;
    },
  },
  created() {
    if (window.localStorage.getItem("jwt") === null) {
      window.localStorage.setItem(
        "jwt",
        CryptoJS.AES.encrypt(JSON.stringify("none"), "secret_key").toString()
      );
      window.localStorage.setItem(
        "roles",
        CryptoJS.AES.encrypt(
          JSON.stringify([{ id: null }]),
          "secret_key"
        ).toString()
      );
      window.localStorage.setItem(
        "user",
        CryptoJS.AES.encrypt(
          JSON.stringify([{ id: null }]),
          "secret_key"
        ).toString()
      );
    }
    this.$store.state.isTransparent = "bg-white";
    const jsonToken = window.localStorage.getItem("jwt");
    let token = "none";
    try {
      token = JSON.parse(
        CryptoJS.AES.decrypt(jsonToken, "secret_key").toString(
          CryptoJS.enc.Utf8
        )
      );
    } catch (e) {
      token = "none";
    }

    if (token && token !== "none") {
      Source.CheckJwt({ jwt: token })
        .then((response) => {
          if (!response || !response.data) {
            if (getRouteSection(this.$route) !== "signIn") {
              this.$router.push(signInUrl(currentFullPath(this.$route)));
            }
          }
        })
        .catch(() => {
          if (getRouteSection(this.$route) !== "signIn") {
            this.$router.push(signInUrl(currentFullPath(this.$route)));
          }
        });
    } else {
      if (getRouteSection(this.$route) !== "signIn") {
        this.$router.push(signInUrl(currentFullPath(this.$route)));
      }
    }
  },
  mounted() {
    const sidenav_show = document.querySelector(".g-sidenav-show");
    if (JSON.parse(window.localStorage.getItem("sidenavPin"))) {
      sidenav_show.classList.remove("g-sidenav-hidden");
      sidenav_show.classList.add("g-sidenav-pinned");
      this.logoMain = true;
    } else {
      sidenav_show.classList.add("g-sidenav-hidden");
      sidenav_show.classList.remove("g-sidenav-pinned");
      this.logoMain = false;
    }

    if (
      JSON.parse(
        CryptoJS.AES.decrypt(
          window.localStorage.getItem("user"),
          "secret_key"
        ).toString(CryptoJS.enc.Utf8)
      ).companyId != undefined
    ) {
      const userId = JSON.parse(
        CryptoJS.AES.decrypt(
          window.localStorage.getItem("user"),
          "secret_key"
        ).toString(CryptoJS.enc.Utf8)
      ).companyId.toString();
      if (this.connection.state != SignalR.HubConnectionState.Connected) {
        this.connection.start().then(() => {
          this.connection
            .invoke("SetUserId", `${userId}`)
            .catch((err) => console.error(err));
        });
      }
    }
    this.connection.on("ReceiveDoctorMessage", () => {
      const val =
        JSON.parse(window.localStorage.getItem("message")) === null
          ? 0
          : JSON.parse(window.localStorage.getItem("message"));
      window.localStorage.setItem("message", val + 1);
      this.bindNavbar = false;
      setTimeout(() => {
        this.bindNavbar = true;
      }, 5);
    });
    this.connection.on("ReceiveAllDoneMessage", () => {
      window.localStorage.setItem("message", 0);
      this.bindNavbar = false;
      setTimeout(() => {
        this.bindNavbar = true;
      }, 5);
    });
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"]),
    getDateNow() {
      var customDate = new Date();

      var day = customDate.getDate();
      var month = customDate.getMonth() + 1;
      var year = customDate.getFullYear();
      var hours = customDate.getHours();
      var minutes = customDate.getMinutes();
      var seconds = customDate.getSeconds();

      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      var formattedDate =
        day +
        "." +
        month +
        "." +
        year +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;

      return formattedDate;
    },
    updateSide() {
      const sidenav_show = document.querySelector(".g-sidenav-show");
      if (sidenav_show.classList.contains("g-sidenav-hidden")) {
        sidenav_show.classList.remove("g-sidenav-hidden");
        sidenav_show.classList.add("g-sidenav-pinned");
        window.localStorage.setItem("sidenavPin", true);
        this.logoMain = true;
      } else {
        sidenav_show.classList.add("g-sidenav-hidden");
        sidenav_show.classList.remove("g-sidenav-pinned");
        window.localStorage.setItem("sidenavPin", false);
        this.logoMain = false;
      }
    },
    toPdf(table, info, value) {
      document.body.style.overflow = "hidden";
      if (value === 0) {
        this.clinicInfo = info;
        this.clinicTable = table;
        this.clinicReyesVis = true;
      }
      if (value === 1) {
        this.clinicAktVis = true;
        this.clinicAktInfo = info;
        this.clinicTable = table;
        this.retentionSumSum = table.reduce(function (acc, obj) {
          return acc + obj.retentionSum;
        }, 0);
        this.eksperText =
          table.length > 0 || info.deductionSum != 0
            ? "Ekspertiza nəticəsində aşağıdakı çatışmamazlıq aşkar edilmişdir"
            : "Müayinə-müalicə işinin aparılmasında nöqsanlar müşahidə edilməmişdir.";
      }

      this.sideVis = false;
      this.loading = false;
      setTimeout(() => {
        print();
        document.body.style.overflow = "";
        this.clinicReyesVis = false;
        this.clinicAktVis = false;
        this.sideVis = true;
      }, 200);
    },
    setLoading() {
      this.loading = true;
    },
    company() {
      return JSON.parse(
        CryptoJS.AES.decrypt(
          window.localStorage.getItem("user"),
          "secret_key"
        ).toString(CryptoJS.enc.Utf8)
      ).companyName;
    },
    bigImg() {
      this.logoMain = true;
    },
    getRoute() {
      return getRouteSection(this.$route);
    },
    smallImg() {
      const sidenav_show = document.querySelector(".g-sidenav-show");
      if (sidenav_show.classList.contains("g-sidenav-hidden")) {
        this.logoMain = false;
      }
    },
  },
};
</script>

<style>
main {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin: 0;
}

.main-content {
  flex: 1;
}

.app-nav-sticky {
  background: transparent;
}
</style>
